<template>
  <div class="page-root">
    <div class="page-wrapper">
      <header id="header">
        <div>
          <img id="marca" src="@/assets/img/logo-onyxerp-invertido.svg"
            alt="Marca" />
        </div>
        <div>
          <span style="color: white">{{ logo_text }}</span>
        </div>
      </header>

      <main>
        <div class="wrapper">
          <h1 id="chamada_tit">{{ primary_text }}</h1>
          <div class="about_app hide-on-med-and-down">
            <h6 id="about_app_tit">{{ selected_app_name ? `Sobre a ${selected_app_name}` : 'Sobre os Aplicativos' }}</h6>
            <h6 id="about_app_desc">{{ selected_app_name ? selected_app_text : 'Selecione um aplicativo para ver mais informações sobre ele.' }}</h6>
          </div>
          <ul id="apps">
            <template v-for="(app, i) in apps">
              <li v-bind:key="i" class="app_items" @click="visitApp(app)" v-on:mouseenter="hoverApp(app)" v-on:mouseleave="unhoverApp()">
                <div class="circ">
                  <img v-if="app['icone_url']"
                    class="material-icons"
                    v-bind:src="app['icone_url']"
                    height="40"
                  />
                  <i v-else class="material-icons">{{ app['icone_class'] }}</i>
                </div>
                <p style="user-select: none">{{ app['nome'] }}</p>
              </li>
            </template>
          </ul>
        </div>
      </main>

      <footer>
        <div>
          <a href="https://www.braconsultoria.com.br/">
            <img src="@/assets/img/bra_logo_branco.svg" alt="Bra Logo" width="100">
          </a>
          <p class="copyright">© {{ year }} OnyxERP. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>

    <!-- Background -->
    <div>
      <div id="bg-app"
        v-bind:style="`background: transparent no-repeat fixed center 0% / cover url('${selected_bg_image.url}')`">
        <div class="bg-backdrop"></div>
      </div>
    </div>

    <div v-if="selected_bg_image.descricao" class="authorBG-wrapper hide-on-med-and-down">
      <i class="material-icons">info</i>
      <span class="authorBG-text">{{ selected_bg_image.descricao }}</span>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import configProd from '../../_doc/config-prod';
import router from '../router';

function mapMetaApp(app) {
  const icone = app.app_icone || ''
  return {
    nome: app.app_nome,
    descricao: app.app_descricao,
    url: app.app_url,
    icone_url: icone.indexOf('http') === 0 ? icone : '',
    icone_class: icone.indexOf('http') === 0 ? '' : icone
  }
}

function mapMetaWallpaper(img, index) {
  return {
    ordem: index,
    descricao: `${img.about} ${img.author}.`,
    imagem_url: img.img_url
  }
}

export default {
  name: "Home",
  components: {},
  data() {
    const metaData = this.$store.state.meta.data.metas.value.ptbr
    return {
      meta: this.$store.state.meta.data,
      apps: (metaData.apps_list || []).map(mapMetaApp),
      images_bg_settings: metaData.img_bkgnd_loop,
      primary_text: metaData.tx_anon_msg_pri,
      logo_text: metaData.tx_anon_msg_logo,
      secondary_text: metaData.tx_anon_msg_sec,
      selected_app_name: '',
      selected_app_text: '',
      wallpapers: [],
      aviso_img: '',
      selected_bg_image: {
        ordem: 0,
        descricao: null,
        url: null
      },
      year: new Date().getFullYear()
    }
  },
  methods: {
    initMaterialize() {
      setTimeout(() => M.Tooltip.init(document.querySelectorAll('.tooltipped')), 100)
    },
    async getConfigData() {
      try {
        const { data } = await Axios.get(`${configProd.URL_SOCIAL_API_V2}/v2/misc/home-config/`);

        if (data.apps && data.apps.length > 0) {
          this.apps = data.apps;
        }

        if (data.wallpapers && data.wallpapers.length > 0) {
          this.wallpapers = data.wallpapers;
          this.preloadWallpapers();
          this.background_images_rotate();
        }

        if (data.texto_h1) {
          this.primary_text = data.texto_h1;
        }

        if (data.texto_p) {
          this.secondary_text = data.texto_p;
        }

        if (data.logo_text) {
          this.logo_text = data.logo_text;
        }

      } catch (error) {
        console.error("Erro ao buscar configuração:", error);

        this.populateDefault()
      }
    },
    populateDefault() {
      const metaData = this.$store.state.meta.data.metas.value.ptbr
      this.apps = (metaData.apps_list || []).map(mapMetaApp)
      this.wallpapers = (metaData.img_bkgnd_loop.loop_images || []).map(mapMetaWallpaper)
      this.preloadWallpapers()
      this.background_images_rotate()
    },
    preloadWallpapers() {
      this.wallpapers.forEach(wallpaper => {
        const img = new Image()
        img.src = wallpaper.imagem_url
      })
    },
    background_images_rotate() {
      if (!this.wallpapers.length) return

      const currentIndex = this.wallpapers.findIndex(w => w.imagem_url === this.selected_bg_image.url)
      const index = currentIndex < this.wallpapers.length - 1 ? currentIndex + 1 : 0

      let selected_bg = this.wallpapers[index]
      this.selected_bg_image.ordem = selected_bg.ordem
      this.selected_bg_image.descricao = selected_bg.descricao
      this.selected_bg_image.url = selected_bg.imagem_url
      this.initMaterialize()
    },
    visitApp(app) {
      let destino;
      try {
        destino = new URL(app.url);
      } catch (e) {
        return;
      }

      if (destino.protocol !== 'http:' && destino.protocol !== 'https:') return;

      window.location.href = destino.href;
    },
    hoverApp(app) {
      this.selected_app_name = app['nome'];
      this.selected_app_text = app['descricao'];
    },
    unhoverApp() {
      this.selected_app_name = '';
      this.selected_app_text = '';
    },
    openModal(img) {
      this.aviso_img = require(`@/assets${img}`);
      const modal = M.Modal.init(document.querySelector('#aviso-modal'));
      modal.open();
    }
  },
  beforeMount() {
    this.getConfigData()
  },
  mounted() {
    setInterval(() => {
      this.background_images_rotate()
    }, this.images_bg_settings.loop_interval);
  }
}
</script>
<style></style>
